import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreditCard } from "lucide-react";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("samtwo_platform_token") || localStorage.getItem("samtwo_token")}` } });

// Coin-paid signup whose renewal card could not be wired to the subscription. The backend
// retries the attach (throttled) on each status read and clears the flag on success.
export const RenewalCardBanner = () => {
  const { platformUser } = usePlatformAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!platformUser) { setMissing(false); return undefined; }
    const check = () => axios.get(`${API}/subscriptions/renewal-card-status`, authHeader())
      .then((r) => setMissing(!!r.data.missing)).catch(() => {});
    check();
    window.addEventListener("renewal-card-updated", check);
    return () => window.removeEventListener("renewal-card-updated", check);
  }, [platformUser, pathname]);

  if (!missing) return null;

  return (
    <div
      data-testid="renewal-card-banner"
      className="w-full px-6 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 text-center"
      style={{ background: "#92400e", color: "#fff" }}
    >
      <CreditCard size={18} className="shrink-0" />
      <span className="text-sm font-medium" data-testid="renewal-card-message">
        {t("billing.renewalCardBanner")}
      </span>
      <button
        onClick={() => navigate("/account/billing")}
        data-testid="renewal-card-billing-btn"
        className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap"
        style={{ background: "#fff", color: "#92400e" }}
      >
        {t("billing.renewalCardCta")}
      </button>
    </div>
  );
};

export default RenewalCardBanner;
